<template>
    <div class="home-banner">
        <el-carousel height="632px" :loop="true" :autoplay="false" arrow="never">
            <el-carousel-item v-for="item in swiperList" :key="item.url">
                <img :src="item.url" />
            </el-carousel-item>
        </el-carousel>
        <div class="banner-wrap">
            <div class="title">中色云</div>
            <div class="text">有色金属加工工业互联网平台</div>
            <div class="button" @click="$router.push('/about')">
                <span>了解详情</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            swiperList: [
                { url: require("@/assets/images/website/home/banner.png") }
            ],

        }
    }
}
</script>

<style lang="less" scoped>
.home-banner {
    position: relative;

    .banner-wrap {
        position: absolute;
        width: 1280px;
        margin: auto;
        top: 233px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 54px;
            color: #293341;
            font-weight: 500;
            margin-bottom: 5px
        }

        .text {
            font-family: PingFangSC-Regular;
            font-size: 28px;
            color: #293341;
            font-weight: 400;
            margin-bottom: 20px
        }

        .button {
            width: 176px;
            height: 46px;
            background: #005FE1;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            span {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 0;
                font-weight: 400;
            }
        }
    }

    .el-carousel__container {
        button {
            display: none
        }
    }

    .el-carousel__item {
        img {
            width: 100%;
            height: 100%
        }
    }
}
</style>